'use client';

import './not-found.css';
import { Title } from '@gsk-tech/react-ui-components';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <Title>404 - Not Found</Title>
    </div>
  );
};

export default NotFound;
